module.exports = __webpack_public_path__ + "static/media/no.b3b4bd01.png";